<template>
  <span v-if="!to">
    <slot />
  </span>

  <a
    v-else-if="isAnchor(to)"
    v-scroll-to="isAnchor(to)"
    :href="isAnchor(to)"
    class="cursor-pointer"
    @click="$emit('click', $event)"
  >
    <slot />
  </a>

  <a
    v-else-if="to.startsWith('http')"
    :href="to"
    rel="nofollow noopener"
    @click="$emit('click', $event)"
  >
    <slot />
  </a>

  <a
    v-else-if="to.startsWith('tel:') || to.startsWith('mailto:')"
    href="#"
    @click.prevent="special(to)"
  >
    <slot />
  </a>

  <a v-else :href="internalSub" @click="internal($event)">
    <slot />
  </a>
</template>

<script>
export default {
  props: {
    to: { type: String, default: null },
  },
  emits: ['click'],
  computed: {
    internalSub() {
      return this.to.replace(this.$store.state.router.sub, '');
    },
  },
  methods: {
    isAnchor(to) {
      if (to.startsWith('#')) return to;
      return false;
    },
    special(to) {
      this.$emit('click');
      window.location.href = to.replace(/ /g, '');
    },
    internal(e) {
      this.$emit('click', e);
      if (e.which === 2 || e.button === 4 || e.ctrlKey || e.metaKey) return;
      if (e.defaultPrevented) return;
      e.preventDefault();
      this.$store.dispatch('router/push', { uri: this.internalSub });
    },
  },
};
</script>
